const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '匿名保护',
    desc: '端到端加密保障爆料人身份安全，即使是平台也无法追溯到原始投稿者。多重隐私保护机制，让你安心分享每一个真实的隐秘八卦和新爆料。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速审核',
    desc: '7×24小时审核团队确保新爆料在最短时间内上线。重大突发事件5分钟即可验证并推送首页，始终保持暗网吃瓜作为全网吃瓜速递第一站的地位。',
  },
  {
    icon: 'ri-group-line',
    title: '社群联动',
    desc: '覆盖全国300+城市的暗网吃瓜群网络，论坛与社群无缝连接。在论坛看到的热门黑料讨论，可以一键分享到对应城市的吃瓜群，让八卦传播更高效。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">
            平台特色
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-200 rounded-xl p-6 md:p-7 text-center group hover:bg-background-300/70 transition-colors"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-500/15 flex items-center justify-center">
                <i className={`${item.icon} text-primary-400 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-200 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}